<template>
  <div>
    <v-row no-glutters class="body-rows">
      <v-col cols="12" md="7" class="left-cols1 pr-md-8">
        <p class="subtitle-2 font-weight-bold mb-2 mb-md-5 txt-666">
          <v-btn :disabled="panstatus" to="/onboarding" icon><v-icon>mdi-arrow-left</v-icon></v-btn>
          Step 1 of 6
        </p>
        <p class="headline font-weight-black mb-2">Start with your PAN card.</p>
        <p class="subtitle-1 font-weight-regular txt-666">It’s your Gateway to Investing!</p>
        <v-alert v-if="rejectdata.app_status == 'rejected' ? rejectdata.stage_wise_approval.pan == 'no' : ''" border="left" colored-border type="info" style="border: 1px solid #ebeef0 !important" class="mt-4 mx-auto rounded-xl text-left py-2" color="warning" elevation="0">
          <span class="subtitle-2 font-weight-regular"
            >Your PAN have been rejected due <b>{{ rejectdata.PAN_reject_reason }}</b></span
          >
        </v-alert>
        <v-alert v-if="panclearalert" border="left" colored-border type="error" style="border: 1px solid #ebeef0 !important" class="mt-4 mx-auto rounded-xl text-left py-2" color="error" elevation="0">
          <span class="subtitle-2 font-weight-regular">Your PAN data has been cleared. Please re-verify your PAN to continue.</span>
        </v-alert>

        <div v-if="!dataloader" class="pt-4">
          <v-form ref="form" v-model="valid" @submit.prevent="panFormSubmit()">
            <p class="font-weight-medium fs-17 mb-0">Your PAN Card Number <span class="red--text">*</span></p>
            <v-text-field counter="10" :maxlength="10" v-model="panInput" :hide-details="!steppanflow && panstatus" :readonly="cardloader || panstatus" oninput="this.value = this.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase()" @input="panStagevalid()" @keypress="panKeypress($event), ash = false" :rules="panRule" class="txt-field mb-1" required>
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                    <g clip-path="url(#clip0_944_29)">
                      <path
                        d="M20.1672 0H1.83339C1.33828 0.00820735 0.867127 0.189025 0.523413 0.502731C0.179703 0.816434 -0.00844779 1.23737 0.000291376 1.67308V2.23077H22.0003V1.67308C22.009 1.23737 21.8209 0.816434 21.4772 0.502731C21.1335 0.189025 20.6623 0.00820735 20.1672 0ZM0.000291376 13.9398C-0.00844779 14.3755 0.179703 14.7965 0.523413 15.1102C0.867127 15.4238 1.33828 15.6047 1.83339 15.6129H20.1672C20.6623 15.6047 21.1335 15.4238 21.4772 15.1102C21.8209 14.7965 22.009 14.3755 22.0003 13.9398V3.34553H0.000291376V13.9398ZM13.4444 5.85484C13.4433 5.78227 13.4748 5.71226 13.5321 5.66008C13.5894 5.6079 13.6678 5.57778 13.7503 5.5763H19.2503C19.3327 5.57778 19.4112 5.6079 19.4685 5.66008C19.5258 5.71226 19.5573 5.78227 19.5562 5.85484V6.41253C19.5573 6.48509 19.5258 6.55511 19.4685 6.60729C19.4112 6.65947 19.3327 6.68959 19.2503 6.69107H13.7503C13.6678 6.68959 13.5894 6.65947 13.5321 6.60729C13.4748 6.55511 13.4433 6.48509 13.4444 6.41253V5.85484ZM13.4444 8.085C13.4433 8.0124 13.4748 7.94243 13.5321 7.89019C13.5894 7.83803 13.6678 7.80794 13.7503 7.80645H19.2503C19.3327 7.80794 19.4112 7.83803 19.4685 7.89019C19.5258 7.94243 19.5573 8.0124 19.5562 8.085V8.64266C19.5573 8.71526 19.5258 8.78524 19.4685 8.8374C19.4112 8.88963 19.3327 8.91972 19.2503 8.92121H13.7503C13.6678 8.91972 13.5894 8.88963 13.5321 8.8374C13.4748 8.78524 13.4433 8.71526 13.4444 8.64266V8.085ZM13.4444 10.3152C13.4433 10.2426 13.4748 10.1726 13.5321 10.1204C13.5894 10.0682 13.6678 10.0381 13.7503 10.0366H19.2503C19.3327 10.0381 19.4112 10.0682 19.4685 10.1204C19.5258 10.1726 19.5573 10.2426 19.5562 10.3152V10.8728C19.5573 10.9454 19.5258 11.0154 19.4685 11.0676C19.4112 11.1198 19.3327 11.1499 19.2503 11.1514H13.7503C13.6678 11.1499 13.5894 11.1198 13.5321 11.0676C13.4748 11.0154 13.4433 10.9454 13.4444 10.8728V10.3152ZM6.72236 5.5763C7.37816 5.5979 7.99892 5.84235 8.45425 6.25828C8.9095 6.67421 9.16392 7.22927 9.16392 7.80674C9.16392 8.38427 8.9095 8.93931 8.45425 9.35525C7.99892 9.77119 7.37816 10.0156 6.72236 10.0373C6.06655 10.0156 5.44577 9.77119 4.99049 9.35525C4.53519 8.93931 4.28082 8.38427 4.28082 7.80674C4.28082 7.22927 4.53519 6.67421 4.99049 6.25828C5.44577 5.84235 6.06655 5.5979 6.72236 5.5763ZM2.56294 12.6958C2.71364 12.2544 3.02058 11.8669 3.43903 11.5898C3.85749 11.3127 4.36557 11.1604 4.88926 11.1551H5.20223C5.68178 11.339 6.19926 11.4339 6.72236 11.4339C7.24545 11.4339 7.76295 11.339 8.24248 11.1551H8.55545C9.07912 11.1604 9.58725 11.3127 10.0057 11.5898C10.4241 11.8669 10.7311 12.2544 10.8818 12.6958C10.9066 12.7765 10.91 12.8611 10.8917 12.9431C10.8734 13.0251 10.8339 13.1023 10.7763 13.1687C10.7187 13.2351 10.6445 13.289 10.5594 13.3261C10.4743 13.3632 10.3806 13.3826 10.2856 13.3827H3.15907C3.06381 13.3825 2.96989 13.3629 2.88462 13.3255C2.79935 13.2881 2.72501 13.234 2.66735 13.1673C2.6097 13.1005 2.5703 13.023 2.55219 12.9407C2.53408 12.8584 2.53776 12.7735 2.56294 12.6927V12.6958Z"
                        fill="#666666"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_944_29">
                        <rect width="22" height="15.6129" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </template>
              <template #append>
                <v-icon v-if="cardloader" color="#999999" size="16">mdi-reload mdi-spin</v-icon>
                <p v-if="panstatus" class="mb-0">
                  <v-icon size="16" color="#37A668">mdi-checkbox-marked-circle-outline</v-icon>
                  <span style="text-decoration: none; color: #37a668; font-size: 12px"><b> Verified</b></span>
                </p>
              </template>
            </v-text-field>
            <p v-if="!steppanflow && (panstatus || (panstat && panname))" class="caption font-weight-medium txt-666 mb-0">
              Your PAN is Verified 
              <span style="text-decoration: none; color: #0037b7"
                ><b>{{ name ? name : panname ? panname : "" }}</b></span
              >
            </p>

            <div v-if="panstatus ? pandob : true">
              <p class="font-weight-medium fs-17 mb-0 mt-3">Enter your date of birth exactly as per your PAN. <span class="red--text">*</span></p>
              <v-menu ref="pandob_menu" v-model="pandob_menu" :close-on-content-click="false" max-width="280px" min-width="auto" transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-bind="attrs" v-on="cardloader || panstat ? {} : on" readonly :rules="dobRule" required :value="pandob ? pandob : ''" placeholder="DD/MM/YYYY" class="txt-field">
                    <template #prepend-inner>
                      <div class="mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.5289 0.666992C10.8049 0.666992 11.0289 0.890992 11.0289 1.16699L11.0292 1.7322C12.0026 1.79894 12.8111 2.13236 13.3833 2.70573C14.0079 3.33306 14.3366 4.23506 14.3333 5.31706V11.3991C14.3333 13.6204 12.9226 15.0004 10.6526 15.0004H5.01392C2.74392 15.0004 1.33325 13.6011 1.33325 11.3484V5.31573C1.33325 3.22052 2.59129 1.87562 4.64304 1.73243L4.64345 1.16699C4.64345 0.890992 4.86745 0.666992 5.14345 0.666992C5.41945 0.666992 5.64345 0.890992 5.64345 1.16699L5.64325 1.71966H10.0286L10.0289 1.16699C10.0289 0.890992 10.2529 0.666992 10.5289 0.666992ZM13.3333 6.60299H2.33325V11.3484C2.33325 13.0591 3.28525 14.0004 5.01392 14.0004H10.6526C12.3813 14.0004 13.3333 13.0764 13.3333 11.3991L13.3333 6.60299ZM10.8007 10.7979C11.0767 10.7979 11.3007 11.0219 11.3007 11.2979C11.3007 11.5739 11.0767 11.7979 10.8007 11.7979C10.5247 11.7979 10.2981 11.5739 10.2981 11.2979C10.2981 11.0219 10.5187 10.7979 10.7947 10.7979H10.8007ZM7.84239 10.7979C8.11839 10.7979 8.34239 11.0219 8.34239 11.2979C8.34239 11.5739 8.11839 11.7979 7.84239 11.7979C7.56639 11.7979 7.33972 11.5739 7.33972 11.2979C7.33972 11.0219 7.56039 10.7979 7.83639 10.7979H7.84239ZM4.87785 10.7979C5.15385 10.7979 5.37785 11.0219 5.37785 11.2979C5.37785 11.5739 5.15385 11.7979 4.87785 11.7979C4.60185 11.7979 4.37452 11.5739 4.37452 11.2979C4.37452 11.0219 4.59585 10.7979 4.87185 10.7979H4.87785ZM10.8007 8.20673C11.0767 8.20673 11.3007 8.43073 11.3007 8.70673C11.3007 8.98273 11.0767 9.20673 10.8007 9.20673C10.5247 9.20673 10.2981 8.98273 10.2981 8.70673C10.2981 8.43073 10.5187 8.20673 10.7947 8.20673H10.8007ZM7.84239 8.20673C8.11839 8.20673 8.34239 8.43073 8.34239 8.70673C8.34239 8.98273 8.11839 9.20673 7.84239 9.20673C7.56639 9.20673 7.33972 8.98273 7.33972 8.70673C7.33972 8.43073 7.56039 8.20673 7.83639 8.20673H7.84239ZM4.87785 8.20673C5.15385 8.20673 5.37785 8.43073 5.37785 8.70673C5.37785 8.98273 5.15385 9.20673 4.87785 9.20673C4.60185 9.20673 4.37452 8.98273 4.37452 8.70673C4.37452 8.43073 4.59585 8.20673 4.87185 8.20673H4.87785ZM10.0286 2.71966H5.64325L5.64345 3.36099C5.64345 3.63699 5.41945 3.86099 5.14345 3.86099C4.86745 3.86099 4.64345 3.63699 4.64345 3.36099L4.6431 2.73479C3.14961 2.86025 2.33325 3.76556 2.33325 5.31573V5.60299H13.3333L13.3333 5.31573C13.3359 4.49239 13.1146 3.85239 12.6753 3.41239C12.2896 3.0256 11.7258 2.79459 11.0295 2.73511L11.0289 3.36099C11.0289 3.63699 10.8049 3.86099 10.5289 3.86099C10.2529 3.86099 10.0289 3.63699 10.0289 3.36099L10.0286 2.71966Z"
                            fill="#121212" />
                        </svg>
                      </div>
                    </template>
                    <template #append>
                      <v-icon v-if="!panstat && cardloader" color="#999999" size="16">mdi-reload mdi-spin</v-icon>
                      <p v-if="panstat" class="mb-0">
                        <v-icon size="16" color="#37A668">mdi-checkbox-marked-circle-outline</v-icon>
                        <span style="text-decoration: none; color: #37a668; font-size: 12px"><b> Verified</b></span>
                      </p>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker no-title v-model="pandob_picker" @input="panDobSave()" :max="new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()).toISOString().substr(0, 10)" min="1940-01-01"></v-date-picker>
              </v-menu>
                <p class="red--text caption fs-12 mb-0 mt-2" v-if="ageResult && ageResult == 'no'">
          A minor under 18 cannot open a trading account directly.<br />
            For assistance in opening a minor account, please contact our Help Desk at 9380108010.
          </p>
            </div>

            <div v-if="panstatus && panstat ? false : steppanflow && panstatus ? panname : true">
              <p class="font-weight-medium fs-17 mb-0 mt-3">Your name as per the PAN <span class="red--text">*</span></p>
              <v-text-field :readonly="cardloader || panstat" type="text" oninput="this.value = this.value.replace('  ', '').replace(/^\./, '').replace(/\.{2,}/g, '.')" v-on:keypress="isLetter($event)" :rules="nameRule" required v-model="panname" class="txt-field">
                <template #prepend-inner>
                  <div class="mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" fill="#212121" />
                      <path d="M5 10C5.53043 10 6.03914 10.2107 6.41421 10.5858C6.78929 10.9609 7 11.4696 7 12H3C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10Z" fill="#212121" />
                      <path d="M9.5 8.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9.5 11.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M4.5 3.5H1.5C1.23478 3.5 0.98043 3.60536 0.792893 3.79289C0.605357 3.98043 0.5 4.23478 0.5 4.5V13.5C0.5 13.7652 0.605357 14.0196 0.792893 14.2071C0.98043 14.3946 1.23478 14.5 1.5 14.5H14.5C14.7652 14.5 15.0196 14.3946 15.2071 14.2071C15.3946 14.0196 15.5 13.7652 15.5 13.5V4.5C15.5 4.23478 15.3946 3.98043 15.2071 3.79289C15.0196 3.60536 14.7652 3.5 14.5 3.5H11.5"
                        stroke="#212121"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path d="M8 0.5C8.39782 0.5 8.77936 0.658035 9.06066 0.93934C9.34196 1.22064 9.5 1.60218 9.5 2V5.5H6.5V2C6.5 1.60218 6.65804 1.22064 6.93934 0.93934C7.22064 0.658035 7.60218 0.5 8 0.5Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </template>
                <template #append>
                  <v-icon v-if="!panstat && cardloader" color="#999999" size="16">mdi-reload mdi-spin</v-icon>
                  <p v-if="panstat" class="mb-0">
                    <v-icon size="16" color="#37A668">mdi-checkbox-marked-circle-outline</v-icon>
                    <span style="text-decoration: none; color: #37a668; font-size: 12px"><b> Verified</b></span>
                  </p>
                </template>
              </v-text-field>
              <div v-if="!panstat && !panname" class="caption txt-666 mb-0">
                <ul>
                  <li>Enter your name as per the PAN card, including a dot and a space,</li>
                  <li>If it is not verified, try the combinations of "FATHER NAME" &lt;SPACE&gt; "YOUR NAME" or "YOUR NAME" &lt;SPACE&gt; "FATHER NAME".</li>
                </ul>
              </div>
            </div>

            <p class="font-weight-medium fs-17 mb-0 mt-3">Your Aadhaar card number <span class="red--text">*</span></p>
            <v-text-field ref="aadharField" counter="12" :maxlength="12" :rules="aadharRule" class="txt-field mb-14" @input="panStagevalid()" @keypress="aadharKeypress($event)" @blur="aadharBlur()" oninput="this.value = this.value.replace(/[^0-9]/g, '')" :readonly="cardloader || aadharloader || aadharstatus" v-model="aadhar">
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none">
                    <g clip-path="url(#clip0_472_4825)">
                      <path
                        d="M23.0085 6.27258C22.874 6.47562 22.8251 6.72001 22.784 6.97474C22.7338 7.28488 22.6807 7.58261 22.5708 7.87455C22.4387 8.22439 22.2168 8.61417 21.8307 8.91926C21.4325 7.84536 20.8525 6.84759 20.116 5.96939C20.5761 5.78596 21.0277 5.78877 21.399 5.84989C21.7074 5.90083 21.9924 6.00388 22.2869 6.11545C22.5284 6.2075 22.765 6.28747 23.0084 6.27258H23.0085ZM18.528 1.80295L18.5279 1.8032L18.5282 1.80312C18.5133 2.04593 18.5933 2.28197 18.6855 2.52297C18.7974 2.81673 18.9007 3.10098 18.9519 3.40864C19.0131 3.77932 19.0159 4.23038 18.8315 4.6898C17.9498 3.95614 16.9485 3.37887 15.871 2.98313C16.1775 2.59467 16.57 2.37195 16.9223 2.23963C17.2149 2.12996 17.5134 2.07711 17.8244 2.02683C18.0796 1.98597 18.3246 1.93734 18.528 1.80295ZM22.3024 10.6739C22.7894 10.7458 23.1769 10.9724 23.4665 11.2093C23.708 11.4073 23.903 11.6387 24.1022 11.8824C24.2651 12.0823 24.43 12.2696 24.6482 12.3782H22.4498C22.4492 11.8069 22.3998 11.2368 22.3024 10.6739ZM6.28752 1.80312L6.28769 1.80328V1.80295C6.49113 1.93726 6.7361 1.98589 6.99136 2.02691C7.30224 2.07703 7.60068 2.12996 7.89332 2.23954C8.24557 2.37187 8.63811 2.59467 8.94452 2.98305C7.86707 3.37876 6.86573 3.95606 5.9841 4.6898C5.79973 4.23038 5.80238 3.77932 5.86381 3.40856C5.91488 3.1009 6.01818 2.81665 6.13001 2.5228C6.2222 2.28189 6.30244 2.04593 6.28752 1.80312ZM1.80719 6.27275L1.80744 6.27283L1.80736 6.27267C2.05076 6.28747 2.28736 6.2075 2.52893 6.11553C2.8234 6.00388 3.10833 5.90083 3.41664 5.84989C3.78804 5.78885 4.2396 5.78604 4.69971 5.96948C3.96329 6.84773 3.38333 7.84548 2.98506 8.91935C2.5989 8.61417 2.37706 8.22447 2.24491 7.87455C2.13498 7.58261 2.08201 7.28488 2.03169 6.97474C1.99065 6.72001 1.94182 6.4757 1.80719 6.27275ZM0.16748 12.3783C0.38576 12.2697 0.550486 12.0824 0.713553 11.8825C0.912517 11.6389 1.10775 11.4075 1.34916 11.2096C1.63882 10.9725 2.02605 10.7459 2.5131 10.6741C2.41575 11.2369 2.36658 11.8071 2.36611 12.3783H0.16748ZM12.4079 0.166992V0.16724L12.4081 0.166992C12.5168 0.384833 12.7046 0.549165 12.9051 0.712009C13.1493 0.910497 13.3813 1.10518 13.5797 1.34601C13.8187 1.6368 14.0473 2.02617 14.1177 2.51644C13.553 2.4197 12.981 2.37109 12.408 2.37113C11.825 2.37113 11.2539 2.42124 10.6981 2.51644C10.7685 2.02625 10.9971 1.6368 11.2361 1.34618C11.4346 1.10518 11.6666 0.910497 11.9107 0.711843C12.1112 0.549248 12.299 0.384833 12.4079 0.166992Z"
                        fill="#121212"
                      />
                      <path d="M10.3656 12.3809L11.1212 12.3787C11.2204 11.7421 11.0263 11.2519 10.3809 11.3689C9.83687 11.4674 9.25257 12.0066 8.89941 12.3787L9.89556 12.3743C10.0066 12.3016 10.2238 12.2184 10.3131 12.2803C10.3464 12.3035 10.3639 12.3364 10.3656 12.3809Z" fill="#121212" />
                      <path
                        d="M13.7634 12.3781H14.706C14.7508 11.2676 14.5715 10.1209 14.054 9.12874C13.5833 8.22604 12.8053 7.61246 11.798 7.46417C10.3276 7.24773 8.84393 7.86876 7.58955 8.75716C6.22383 9.72446 5.09653 11.0382 4.11133 12.3782L5.35651 12.3763C6.4775 10.7913 9.05583 8.38483 10.9525 8.36911C11.5569 8.36415 12.1715 8.50566 12.6259 8.91008C12.9551 9.20318 13.3543 9.77226 13.3347 10.2342C13.3231 10.508 13.0795 10.592 12.8458 10.5071C12.6644 10.4413 12.5362 10.2758 12.4092 10.1018C11.9965 9.53647 11.3528 9.25983 10.6467 9.35626C9.80451 9.47114 8.76061 10.1235 8.08729 10.7167C7.50673 11.2285 6.97367 11.7884 6.47087 12.3782H7.80957C8.30026 11.7872 8.8184 11.2832 9.48443 10.8693C9.69516 10.7384 9.95473 10.5999 10.2276 10.5063C10.9158 10.2703 11.6007 10.3301 11.9048 11.1849C12.0243 11.521 12.0419 11.8159 12.007 12.3561V12.3782H12.9173L12.9196 12.3504C12.9203 12.0546 12.9138 11.8552 12.9406 11.562C12.9636 11.3092 13.0423 11.0474 13.2776 11.0163C13.7776 10.9118 13.7536 12.0215 13.7634 12.3782V12.3781Z"
                        fill="#121212"
                      />
                      <path
                        d="M15.697 12.3787H16.6475C16.6935 11.3484 16.605 10.1278 16.2708 9.06202C16.2064 8.85498 16.1306 8.65161 16.0439 8.45282C15.8416 7.99225 15.5694 7.57534 15.2449 7.19002C14.8841 6.76203 14.4543 6.37713 13.9698 6.07402C13.8261 5.98404 13.6778 5.90169 13.5254 5.82732V5.82715C13.3724 5.75245 13.2153 5.68649 13.0548 5.62957L13.0541 5.62932C11.2034 4.97373 9.33145 5.43993 7.76113 6.29203C7.45881 6.45652 7.16471 6.63562 6.87988 6.82869C6.60537 7.01459 6.33895 7.21213 6.08137 7.42077L6.08079 7.42118C5.71353 7.71872 5.3661 8.03982 5.04071 8.38244C4.96801 8.45927 4.89621 8.53751 4.82641 8.61649C4.63963 8.8278 4.3518 9.12396 4.43719 9.43013C4.50484 9.67295 4.81895 9.60133 4.9283 9.5178C5.09626 9.4279 5.28063 9.2854 5.43856 9.15216C5.65219 8.97171 5.85406 8.77735 6.06571 8.59441C6.9215 7.85422 7.8136 7.28348 8.69228 6.89717C8.88073 6.81421 9.07232 6.73854 9.26662 6.67031C9.45333 6.60472 9.6427 6.54694 9.83424 6.49713L9.83507 6.49688C11.4701 6.07344 13.2468 6.34777 14.3844 7.67789C15.4803 8.95922 15.6803 10.6743 15.697 12.3788V12.3787ZM3.90455 10.9304C4.00668 10.8353 4.11072 10.7112 4.21916 10.5739C4.37087 10.3819 4.38612 10.196 4.3261 10.0618C4.30443 10.0129 4.27181 9.9696 4.23076 9.9352C4.19106 9.90198 4.14405 9.87857 4.09356 9.86689C3.96995 9.83869 3.82206 9.88285 3.69646 10.0353C3.55454 10.2075 3.35847 10.5022 3.31843 10.7629C3.31075 10.8094 3.30925 10.8568 3.31396 10.9037C3.31893 10.9471 3.33054 10.9883 3.35002 11.0259L3.35018 11.0262C3.38218 11.0874 3.43615 11.1197 3.50803 11.1224C3.52303 11.1229 3.53928 11.1222 3.55652 11.1203C3.57335 11.1185 3.59159 11.1151 3.61099 11.1107V11.1108L3.61199 11.1106C3.70881 11.0874 3.80564 11.0224 3.90455 10.9303V10.9304Z"
                        fill="#121212"
                      />
                      <path
                        d="M18.0745 12.3785L18.0812 12.3784H18.0846C18.1841 12.3838 18.3567 12.3382 18.4563 12.1706C18.4761 12.1371 18.4931 12.0988 18.506 12.0554C18.5193 12.0112 18.5284 11.961 18.5322 11.9046L18.5329 11.8931C18.6085 9.25978 17.8 7.07971 16.4274 5.59874C16.1632 5.31333 15.8747 5.05139 15.5651 4.81587C15.2587 4.58298 14.9322 4.37768 14.5895 4.20237H14.5894L14.5839 4.19972L14.5838 4.19956C13.4301 3.61137 12.1216 3.38551 10.8374 3.4941C10.3366 3.5363 9.84144 3.62907 9.35946 3.77099L9.35607 3.77206C8.03528 4.16185 6.80618 4.93554 5.80456 5.95064C5.51231 6.24673 5.24049 6.56222 4.99097 6.89495C5.69339 6.29039 6.44697 5.76009 7.23519 5.33872C7.41092 5.24464 7.58937 5.15572 7.77032 5.07208C7.94933 4.98934 8.13089 4.91222 8.31474 4.84084L8.31524 4.84068L8.31573 4.84043C9.01211 4.5704 9.69861 4.39821 10.3853 4.3213C11.0719 4.24438 11.759 4.26258 12.4567 4.37324C12.9533 4.45214 13.438 4.58182 13.8746 4.76327C13.9593 4.79842 14.0427 4.8358 14.1242 4.87533C14.2048 4.91428 14.2841 4.95564 14.3618 4.99939H14.3619L14.3632 5.00005L14.3631 5.00013C15.9003 5.8399 16.9683 7.56295 17.4386 9.50847C17.6233 10.2734 17.7141 11.0578 17.7091 11.8446V11.8448L17.7088 11.8674C17.7167 12.0781 17.7891 12.2544 17.9131 12.3337C17.9361 12.3484 17.9612 12.36 17.9878 12.3674H17.9879C18.0151 12.3751 18.044 12.379 18.0745 12.3785Z"
                        fill="#121212"
                      />
                      <path d="M15.3259 3.60254C19.0219 4.82035 21.6929 8.2877 21.7085 12.3787H19.8797C20.0007 8.80509 18.4373 5.5794 15.3259 3.60254Z" fill="#121212" />
                      <path
                        d="M4.59498 15.2476H3.85524L3.67203 15.8906H3.08252L3.86262 13.4282H4.60957L5.41164 15.8906H4.79643L4.59498 15.2476ZM3.93947 14.8311H4.5071C4.35821 14.35 4.26171 14.02 4.21777 13.8409H4.2104L4.09326 14.3086L3.93947 14.8311ZM7.31216 15.2476H6.57234L6.3893 15.8906H5.7997L6.57964 13.4282H7.32683L8.12882 15.8906H7.51361L7.31216 15.2476ZM6.65657 14.8311H7.2242C7.07531 14.35 6.97881 14.02 6.93487 13.8409H6.92758L6.81044 14.3086L6.65657 14.8311ZM8.69255 15.8797V13.4611C8.9367 13.4245 9.19792 13.4062 9.47622 13.4062C10.0024 13.4062 10.3802 13.5158 10.6092 13.7357C10.838 13.9555 10.9521 14.2429 10.9521 14.5973C10.9521 15.0162 10.8221 15.3408 10.5615 15.5709C10.3008 15.801 9.89868 15.9161 9.35543 15.9161C9.10399 15.9161 8.88298 15.904 8.69255 15.8797ZM9.26018 13.8629V15.4668C9.29193 15.4741 9.36032 15.4777 9.46528 15.4777C9.74722 15.4777 9.96575 15.4035 10.1202 15.2555C10.2746 15.1075 10.3515 14.8957 10.3515 14.6192C10.3515 14.3659 10.2814 14.1728 10.1403 14.0401C9.99933 13.9074 9.79614 13.8409 9.53118 13.8409C9.42009 13.8409 9.32973 13.8484 9.26018 13.8629ZM11.5599 13.4282H12.1275V14.3744H13.0979V13.4282H13.6656V15.8906H13.0979V14.864H12.1275V15.8906H11.5599V13.4282ZM15.7235 15.2476H14.9838L14.8007 15.8906H14.2111L14.9912 13.4282H15.7382L16.5403 15.8906H15.925L15.7235 15.2476ZM15.068 14.8311H15.6356C15.4867 14.35 15.3903 14.02 15.3463 13.8409H15.339L15.2218 14.3086L15.068 14.8311ZM18.4407 15.2476H17.7009L17.5178 15.8906H16.9282L17.7082 13.4282H18.4553L19.2573 15.8906H18.6421L18.4407 15.2476ZM17.7851 14.8311H18.3527C18.2038 14.35 18.1073 14.02 18.0634 13.8409H18.0561L17.9389 14.3086L17.7851 14.8311ZM19.821 15.8905V13.4611C20.0287 13.4245 20.2838 13.4062 20.5865 13.4062C20.9601 13.4062 21.2286 13.4678 21.3922 13.5908C21.5557 13.7137 21.6375 13.8897 21.6375 14.1187C21.6375 14.2551 21.5966 14.3781 21.5142 14.4883C21.4341 14.5969 21.3224 14.6783 21.1944 14.7215V14.736C21.3482 14.7934 21.4593 14.9444 21.5277 15.1891C21.6534 15.6299 21.7217 15.8638 21.7327 15.8906H21.1541C21.1053 15.7993 21.0467 15.6081 20.9783 15.317C20.9442 15.1709 20.8977 15.0686 20.8392 15.0101C20.7806 14.9516 20.6866 14.9225 20.5572 14.9225H20.3814V15.8906H19.821V15.8905ZM20.3814 13.8409V14.5169H20.6158C20.7574 14.5169 20.869 14.4846 20.9509 14.4207C21.0327 14.3568 21.0736 14.2709 21.0736 14.1625C21.0736 14.0541 21.0369 13.97 20.9631 13.9111C20.8893 13.8519 20.7842 13.8227 20.6488 13.8227C20.5157 13.8227 20.4266 13.8289 20.3814 13.8409Z"
                        fill="#121212"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_472_4825">
                        <rect width="24.8705" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </template>
              <template #append>
                <v-icon v-if="aadharloader" color="#999999" size="16">mdi-reload mdi-spin</v-icon>
                <p v-if="aadharstatus" class="mb-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1003_20)">
                      <path
                        d="M5.66659 10.333L10.3333 5.66633M5.99992 2.66634V1.33301M9.99992 13.333V14.6663M2.66659 5.99967H1.33325M13.3333 9.99967H14.6666M3.27606 3.27582L2.33325 2.33301M12.7238 12.7235L13.6666 13.6663M7.99994 11.7709L6.58573 13.1851C5.54433 14.2265 3.85589 14.2265 2.81449 13.1851C1.77309 12.1437 1.77309 10.4552 2.81449 9.41383L4.22871 7.99962M11.7712 7.99962L13.1854 6.5854C14.2268 5.544 14.2268 3.85556 13.1854 2.81417C12.144 1.77277 10.4556 1.77277 9.41415 2.81417L7.99994 4.22838"
                        stroke="#37A668"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1003_20">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span style="text-decoration: none; color: #37a668; font-size: 12px"><b> Linked</b></span>
                </p>
              </template>
            </v-text-field>
            <p v-if="kraloader" class="font-weight-bold mt-2 mb-0">Please wait while we retrieve your KRA data...</p>

            <div class="d-none d-md-inline-flex">
              <v-btn v-if="panstatus && aadharstatus && panstageis" style="border: 2px solid #444 !important" outlined height="48px" @click="change()" :loading="changeloader" color="#000" class="text-none rounded-pill elevation-0 mr-4 mt-6"><span class="subtitle-1 font-weight-medium px-6">Clear</span></v-btn>

              <v-btn height="48px" v-if="panstatus && aadharstatus" @click="toNext()" :loading="cardloader || aadharloader" color="#000" class="white--text text-none rounded-pill elevation-0 mt-6"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>

              <v-btn v-else height="48px" type="submit" :disabled="!valid || aadharloader || cardloader || ageResult == 'no'" :loading="cardloader || aadharloader" color="#000" class="white--text text-none rounded-pill elevation-0 mt-6"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>
            </div>

            <v-footer padless color="#fff" class="btn-footer btn-footer px-3 pt-3 pb-1 d-md-none">
              <v-row>
                <v-col cols="6">
                  <v-btn v-if="panstatus && aadharstatus && panstageis" style="border: 2px solid #444 !important" outlined height="48px" @click="change()" :loading="changeloader" color="#000" block class="text-none rounded-pill elevation-0"><span class="subtitle-1 font-weight-medium px-6">Clear</span></v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn height="48px" v-if="panstatus && aadharstatus" @click="toNext()" :loading="cardloader || aadharloader" block color="#000" class="white--text text-none rounded-pill elevation-0"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>
                  <v-btn v-else height="48px" type="submit" :disabled="!valid || aadharloader || cardloader || ageResult == 'no'" :loading="cardloader || aadharloader" block color="#000" class="white--text text-none rounded-pill elevation-0"
                    ><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn
                  >
                </v-col>
              </v-row>
            </v-footer>
          </v-form>
        </div>

        <div v-else>
          <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
            <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
          </v-card>
        </div>
      </v-col>
      <v-col cols="5" class="rgt-cols d-none d-md-block pt-0">
        <v-container fill-height class="d-block text-center">
          <img src="@/assets/onb4.svg" class="rgt-img" alt="rgt-img" />
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import {validationMixin} from "vuelidate";
import {required, alphaNum, helpers} from "vuelidate/lib/validators";

const alpha = helpers.regex("alpha", /[A-Z]{5}[0-9]{4}[A-Z]{1}/);
export default {
  mixins: [validationMixin],
  validations: {
    panInput: {required, alphaNum, alpha},
    panFile: {required},
  },
  data: () => ({
    panInput: "",
    panstatus: false,
    errorDescPAN: false,
    name: null,
    valid: false,
    aadhar: "",
    loader: false,
    cardloader: false,
    aadharloader: false,
    ash: false,
    panRule: [(v) => !!v || "PAN number is required", (v) => (v && v.length === 10) || "PAN number must be 10 characters", (v) => !v || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || "PAN number must be valid"],
    panname: null,
nameRule: [
  (v) => !!v || "Name is required",
  (v) => /^[A-Za-z.\s]+$/.test(v) || "Only letters and dots are allowed",
  (v) => !/\.{2,}/.test(v) || "Consecutive dots are not allowed",
  (v) => !/\.$/.test(v) || "Name cannot end with a dot",
  (v) => (v && v.trim().replace(/[.\s]/g, '').length >= 1) || "Enter a valid name"
],

    pandob: null,
    pandob_menu: false,
    pandob_picker: null,
    aadharTouched: false,
    aadharstatus: false,
    validateRes: [],
    dataloader: null,
    rejectdata: [],
    rekycdata: false,
    panstageis: false,

    panstat: null,

    steppanflow: false,

    exdatamodel: [],
    kraloader: false,
    changeloader: false,
    panclearalert: false,
    KRAInstdialog: false,
    ageResult:""
  }),
  computed: {
    aadharRule() {
      return [
        (v) => {
          if (!this.aadharTouched && v && v.length < 12) return true;
          return !!v || "Aadhaar Number is required";
        },
        (v) => {
          if (!this.aadharTouched && v && v.length < 12) return true;
          return /^\d{12}$/.test(v) || "Aadhaar number must be valid";
        },
      ];
    },
    dobRule() {
      return [
        (v) => !!v || "Date of birth is required",
        (v) => (v || "").length == 10 || "Date of birth must be valid",
        (v) => {
          if (!v || v.length < 10) return true;
          const parts = v.split("/");
          if (parts.length !== 3) return "Enter your valid date of birth";
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          if (!day || !month || !year) return "Enter your valid date of birth";
          if (month < 1 || month > 12) return "Invalid month";
          const currentYear = new Date().getFullYear();
          if (year > currentYear) return "Year cannot be greater than " + currentYear;
          if (year < 1900) return "Enter a valid year";
          const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            daysInMonth[1] = 29;
          }
          if (day < 1 || day > daysInMonth[month - 1]) return "Invalid date for the given month";
          return true;
        },
      ];
    },
  },
  created() {
    let config = {
      method: "post",
      url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
      headers: {
        "Content-Type": "application/json",
        "mobile":atob(localStorage.getItem("hash"))
      },
    };

    let axiosThis = this;
    axios
      .request(config)
      .then((response) => {
        let p = response.data.data_type;
        if (
          response.data.data_type &&
          response.data.stage_wise_approval.pan != "yes" && response.data.kra_esigned != 'Yes' &&
          (p.stage == "onboard" ||
            p.stage == "pan" ||
            p.stage == "verification" ||
            p.stage == "digilocker" ||
            p.stage == "panproof" ||
            p.stage == "personal" ||
            p.stage == "bank" ||
            p.stage == "bankproof" ||
            p.stage == "segment" ||
            p.stage == "declartaion" ||
            p.stage == "signature" ||
            p.stage == "nominee" ||
            p.stage == "selfie" ||
            p.stage == "submit")
        ) {
          axiosThis.$emit("clicked", 1, response.data);
          axiosThis.panstageis = response.data.stage_wise_approval && response.data.stage_wise_approval.pan == "yes" ? false : true;
          axiosThis.rekycdata = response.data.data_type.rekyc == "Yes" ? true : false;
          axiosThis.steppanflow = false;
          response.data.app_status == "rejected" && response.data.stage_wise_approval.pan == "no" ? (axiosThis.rejectdata = response.data) : (axiosThis.rejectdata = []);
          if (p.check && p.check.pan == "yes") {
            axiosThis.panclearalert = true;
            axiosThis.dataloader = false;
          } else {
            axiosThis.getSignupPANData();
          }
        } else {
          axiosThis.$router.push(p ? {name: p.stage} : "/");
        }
      })
      .catch((error) => {
        console.log(error);
        axiosThis.$emit("snack", 0, error);
      });
  },
  methods: {
    getSignupPANData() {
      this.dataloader = true;
      var json_data = {
        mobile: atob(localStorage.getItem("hash")),
      };
      var config = {
        method: "post",
        url: api.api_url + "/getSignupPAN",
        headers: {"Content-Type": "application/json","mobile":atob(localStorage.getItem("hash"))},
        data: JSON.stringify(json_data),
      };

      let axiosThis = this;
      axios(config)
        .then(function (response) {
          if (axiosThis.rekycdata && !response.data["AADHAR"]) {
            let pan = localStorage.getItem("L8nbe2ihTzm");
            axiosThis.panInput = pan ? atob(pan) : response.data["PAN"] ? response.data["PAN"] : null;
          } else if (response.data["AADHAR"] && response.data["AADHAR"].length == 12 && (response.data["PAN"] == "" || response.data["Name"] == "" || response.data["PAN"] == null || response.data["Name"] == null)) {
            axiosThis.name = "";
            axiosThis.aadharstatus = false;
            axiosThis.panstatus = false;
            axiosThis.$emit("changed", 1);
          } else if (response.data["Name"] && response.data["PAN"] && response.data["AADHAR"]) {
            axiosThis.panstat = true;
            axiosThis.name = response.data["Name"];
            axiosThis.panInput = response.data["PAN"];
            axiosThis.aadhar = response.data["AADHAR"];
            axiosThis.pandob = response.data["dob"];
            if (response.data["dob"]) {
              const parts = response.data["dob"].split('/');
              if (parts.length === 3) axiosThis.pandob_picker = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            axiosThis.panname = response.data["Name"];
            axiosThis.aadharstatus = true;
            axiosThis.panstatus = true;
            axiosThis.aadharloader = false;
            axiosThis.KRAInstdialog = false;
          }
          axiosThis.dataloader = false;
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.dataloader = false;
          axiosThis.$emit("snack", 0, error);
        });
    },
   isLetter(e) {
  let char = String.fromCharCode(e.keyCode);
  if (char === '.' && (!this.panname || this.panname.length === 0)) {
    e.preventDefault();
    return;
  }
  if (char === '.' && this.panname && this.panname.endsWith('.')) {
    e.preventDefault();
    return;
  }
  if (/^[A-Za-z.\s]$/.test(char)) return true;
  else e.preventDefault();
},

    panKeypress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122))) {
        $event.preventDefault();
      }
    },
    aadharKeypress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    aadharBlur() {
      this.aadharTouched = true;
      this.$nextTick(() => {
        if (this.$refs.aadharField) {
          this.$refs.aadharField.validate(true);
        }
      });
    },
    dobvalidation($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // Allow only digits (48-57) and forward slash (47)
      if (keyCode === 47 || (keyCode >= 48 && keyCode <= 57)) return true;
      $event.preventDefault();
    },
    panFormSubmit() {
      this.aadharTouched = true;
      if (this.$refs.form.validate() == true) {
        this.checkAge();
      }
    },
    panDobSave() {
      if (this.pandob_picker) {
        const [year, month, day] = this.pandob_picker.split('-');
        this.pandob = `${day}/${month}/${year}`;
      }
      this.pandob_menu = false;
      this.ash = false;
    },
    panStagevalid(e) {
      if (e == "dob" && this.pandob && this.pandob.length > 0) {
        this.pandob = this.setformatDOB(this.pandob);
      }
    },
    checkAge() {
      if (!this.pandob) {
        this.ageResult = 'Please enter DOB';
        return;
      }
      const [day, month, year] = this.pandob.split('/').map(Number);
      if (!day || !month || !year) {
        this.ageResult = 'Invalid DOB format';
        this.$emit("snack", 0, "Invalid date of birth format. Please use the format DD/MM/YYYY.");
        return;
      }
      const dob = new Date(year, month - 1, day);
      const today = new Date();
      const age18Date = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      this.ageResult = dob <= age18Date ? 'yes' : 'no';
      if(this.ageResult == 'yes'){
          this.panFetch();
      }else{
        this.cardloader = false
        this.aadharloader = false
        this.$emit("snack", 0, "A minor under 18 cannot open a trading account directly.");

      }
    },
    setformatDOB(d) {
      var o;
      if (d && d.length == 2) {
        o = d + "/";
      } else if (d.length == 5) {
        o = d + "/";
      } else {
        o = d;
      }
      return o;
    },
    toNext() {
      if (this.KRAInstdialog) {
        this.setKradataUpdate("yes");
      } else if (this.panclearalert) {
        this.updatePanData();
      } else {
        this.$emit("changed", 0);
        if (this.rejectdata.app_status == "rejected" && this.rejectdata.stage_wise_approval.pan == "no") {
          this.$emit("steged", "pan");
        } else {
          this.$emit("clicked", "verification");
          localStorage.removeItem("L8nbe2ihTzm");
        }
      }
    },
    updatePanData() {
      var axiosThis = this;
      axiosThis.cardloader = true;
      var mobile = atob(localStorage.getItem("hash"));
      axios.post(api.api_url + "/update_pan_data/" + mobile, {}, {
        headers: {
          "Content-Type": "application/json",
          "mobile": mobile
        }
      }).then(function (response) {
        axiosThis.cardloader = false;
        if (response.data) {
          axiosThis.panclearalert = false;
          axiosThis.$emit("changed", 0);
          axiosThis.$emit("clicked", "verification");
          localStorage.removeItem("L8nbe2ihTzm");
        }
      }).catch(function (error) {
        console.log(error);
        axiosThis.cardloader = false;
        axiosThis.$emit("snack", 0, error);
      });
    },
    change() {
      this.$v.$touch();
      this.ash = true;
      if (this.panInput) {
        var axiosThis = this;
        axiosThis.changeloader = true;
        axios.post(api.api_url + "/clear_stage_data", {
          mobile: atob(localStorage.getItem("hash")),
          type: "pan",
          upload: false,
        }).then(function () {
          axios.request({
            method: "post",
            url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
            headers: { "Content-Type": "application/json", "mobile": atob(localStorage.getItem("hash")) },
          }).then(function (response) {
            axiosThis.changeloader = false;
            if (response.data.data_type && response.data.data_type.check && response.data.data_type.check.pan == "yes") {
              axiosThis.panclearalert = true;
              axiosThis.name = "";
              axiosThis.$refs.form.reset();
              axiosThis.panname = null;
              axiosThis.pandob = null;
              axiosThis.pandob_picker = null;
              axiosThis.panstat = false;
              axiosThis.aadharstatus = false;
              axiosThis.panstatus = false;
              axiosThis.aadharTouched = false;
              axiosThis.ageResult = "";
              axiosThis.steppanflow = false;
            } else {
              axiosThis.panclearalert = false;
              axiosThis.name = "";
              axiosThis.$refs.form.reset();
              axiosThis.panname = null;
              axiosThis.pandob = null;
              axiosThis.pandob_picker = null;
              axiosThis.panstat = false;
              axiosThis.aadharstatus = false;
              axiosThis.panstatus = false;
              axiosThis.aadharTouched = false;
              axiosThis.$emit("changed", 1);
              axiosThis.ageResult = "";
              axiosThis.steppanflow = false;
            }
          }).catch(function (error) {
            axiosThis.changeloader = false;
            axiosThis.$emit("snack", 0, error);
          });
        }).catch(function (error) {
          axiosThis.changeloader = false;
          axiosThis.$emit("snack", 0, error);
        });
      } else {
        this.steppanflow = false;
      }
    },
    panFetch() {
      this.$v.$touch();
      this.ash = true;
      if (this.$refs.form.validate() == true && this.panInput && this.aadhar) {
        this.aadharloader = true;
        this.cardloader = true;
        this.$v.$reset();
        var axiosThis = this;
        var json_data = {mobile: atob(localStorage.getItem("hash")), pan: this.panInput, aadharNumber: this.aadhar, pandob: this.pandob, panname: this.panname};
        this.steppanflow ? (json_data["type"] = "name") : "";
        var config = {
          method: "post",
          url: api.api_url + "/getSignupPAN",

          headers: {"Content-Type": "application/json","mobile":atob(localStorage.getItem("hash"))},
          data: JSON.stringify(json_data),
        };
        axios(config)
          .then(function (res) {
            var d = res.data;
            var abc = false;

            if (d && ((d.msg && d.msg.includes("debarred")) || (d.data && typeof d.data === "string" && d.data.includes("debarred")))) {
              var debarredMsg = (d.msg || d.data).replace("is debarred in SEBI or NSE", "is debarred by SEBI or NSE and is not eligible to proceed.");
              axiosThis.$emit("snack", 0, debarredMsg);
              axiosThis.aadharloader = false;
              axiosThis.cardloader = false;
            } else if (d && d.status) {
              if (d.pan_status && d.pan_status !== "EXISTING AND VALID") {
                axiosThis.panstat = false;
                axiosThis.panstatus = false;
                axiosThis.aadharstatus = false;
                axiosThis.aadharloader = false;
                axiosThis.cardloader = false;
                axiosThis.$emit("snack", 0, "PAN status: " + d.pan_status);
                return;
              }
              if (d.name_flag == "Y" && d.dobflag == "Y" && d.aadhar_seeding_status == "YES") {
                axiosThis.aadharstatus = true;
                axiosThis.panname = d.Name;
                axiosThis.panstatus = true;
                axiosThis.panstat = true;
                abc = true;
                axiosThis.steppanflow = false;
              } else {
                axiosThis.steppanflow = true;
                axiosThis.panstat = false;
                if (d.name_flag != "Y" && d.dobflag != "Y") {
                  axiosThis.panname = null;
                  axiosThis.pandob = null;
                  axiosThis.$emit("snack", 0, "Your name and date of birth don't match as per the income tax database.");
                } else if (d.name_flag != "Y") {
                  axiosThis.panname = null;
                  axiosThis.$emit("snack", 0, "Your name doesn't match as per the income tax database.");
                } else if (d.dobflag != "Y") {
                  axiosThis.pandob = null;
                  axiosThis.$emit("snack", 0, "Your date of birth doesn't match as per the income tax database.");
                }
                if (d.aadhar_seeding_status == "YES") {
                  axiosThis.aadharstatus = true;
                  axiosThis.panstatus = false;
                } else {
                  axiosThis.aadharstatus = false;
                  axiosThis.panstatus = false;
                }
                axiosThis.aadharloader = false;
                axiosThis.cardloader = false;
              }
            } else {
              axiosThis.aadharloader = false;
              axiosThis.cardloader = false;
              if (d && (d.data == "Client with this details already exists" || d.data == "already exist")) {
                axiosThis.$emit("snack", 0, d.msg);
              } else if (d && d.msg && d.msg.includes("debarred")) {
                axiosThis.$emit("snack", 0, d.msg.replace("is debarred in SEBI or NSE", "is debarred by SEBI or NSE and is not eligible to proceed."));
              } else {
                axiosThis.$emit("snack", 0, d && d.msg ? d.msg == 'Your pan and aadhar not linked' ? 'Your pan and Aadhaar not linked' : 'Your pan and Aadhaar not linked' : d);
              }
            }

            if (abc) {
              axiosThis.aadharstatus = true;
              axiosThis.getKraDetails(axiosThis.panInput, axiosThis.pandob, axiosThis.panname);
            }
          })
          .catch(function (error) {
            console.log(error);
            axiosThis.panstat = false;
            axiosThis.aadharloader = false;
            axiosThis.cardloader = false;
            axiosThis.$emit("snack", 0, error);
          });
      }
    },
    getKraDetails(pan, dob) {
      this.cardloader = true;
      this.kraloader = true;
      let data = JSON.stringify({
        pan: pan,
        dob: dob,
        mobile: atob(localStorage.getItem("hash")),
      });

      let config = {
        method: "post",
        // url: api.apiDurl + "/PANDetailsFetchALLKRA",
        url: api.apipan + "/PANDetailsFetchALLKRA",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var axiosThis = this;

      axios
        .request(config)
        .then((res) => {
          var sc = res.data && res.data.state_check;
          var is403 = sc === 403 || sc === "403" || (sc && (sc.status === 403 || sc.code === 403 || sc.statusCode === 403));
          if (is403) {
            var msg403 = (sc && (sc.message || sc.msg)) || res.data.message || res.data.msg;
            if (msg403) axiosThis.$emit("snack", 0, msg403);
          }
          var c = res.data.personal_details;
          if (res.data && c && Object.entries(c).length > 0 && c.APP_NAME && axiosThis.panname.toUpperCase() == c.APP_NAME.toUpperCase()) {
            axiosThis.KRAInstdialog = true;
            axiosThis.exdatamodel = res.data;
          } else {
            axiosThis.setKradataUpdate("no", true);
            axiosThis.KRAInstdialog = false;
            axiosThis.exdatamodel = [];
          }
          axiosThis.panstat = true;
          axiosThis.panstatus = true;
          axiosThis.aadharloader = false;
          axiosThis.cardloader = false;
          axiosThis.kraloader = false;
        })
        .catch((error) => {
          console.log(error);
          if (error && error.response && error.response.status === 403 && error.response.data && error.response.data.state_check) {
            axiosThis.$emit("snack", 0, error.response.data.state_check);
          }
          axiosThis.setKradataUpdate("no", true);
          axiosThis.exdatamodel = [];
          axiosThis.KRAInstdialog = false;
          axiosThis.aadharloader = false;
          axiosThis.cardloader = false;
          axiosThis.kraloader = false;
        });
    },
    setKradataUpdate(key, next) {
      this.cardloader = true;
      var raw = this.exdatamodel;
      raw["mobile"] = atob(localStorage.getItem("hash"));
      raw["pan"] = this.panInput;
      raw["kra_code"] = key;
      let data = key == "no" ? {kra_code: "no", pan: (this.panInput || "").trim(), mobile: atob(localStorage.getItem("hash"))} : raw;

      let config = {
        method: "post",
        url: api.api_url + "/pushKra",
        headers: {
          "Content-Type": "application/json",
          "mobile":atob(localStorage.getItem("hash"))
        },
        data: JSON.stringify(data),
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.status == "updated") {
            if (!next) {
              axiosThis.KRAInstdialog = false;
              axios.request({
                method: "post",
                url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
                headers: { "Content-Type": "application/json", "mobile": atob(localStorage.getItem("hash")) },
              }).then(function (response) {
                axiosThis.$emit("clicked", 1, response.data);
                axiosThis.cardloader = false;
                axiosThis.toNext();
              }).catch(function () {
                axiosThis.cardloader = false;
                axiosThis.toNext();
              });
            } else {
              axiosThis.cardloader = false;
            }
          } else {
            axiosThis.$emit("snack", 0, res.data);
            axiosThis.cardloader = false;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.cardloader = false;
          axiosThis.$emit("snack", 0, error);
        });
    },
  },
  mounted() {},
};
</script>
